export const elevations = {
  none: 'none',
  small: '0px 4px 8px rgba(54, 54, 91, 0.08)',
  medium: '0px 4px 8px rgba(54, 54, 91, 0.12)',
  large: '0px 10px 24px rgba(29, 42, 68, 0.12)',
};

export type ThemeElevations = typeof elevations;
